import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../data/mockData';

const TestimonialsSection = () => {
  return (
    <section id="depoimentos" className="py-20 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900 to-blue-800">
        <img 
          src="https://images.unsplash.com/photo-1488998427799-e3362cec87c3?w=1920&q=80" 
          alt="Background"
          className="w-full h-full object-cover opacity-10"
        />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            O que dizem nossos <span className="text-orange-400">Alunos Aprovados</span>
          </h2>
          <p className="text-xl text-gray-200">
            Histórias reais de quem conquistou a aprovação estudando com o Direito em 5 Minutos
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.id}
              className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:-translate-y-2 hover:shadow-2xl"
            >
              {/* Quote Icon */}
              <div className="mb-6">
                <Quote className="text-orange-400" size={40} />
              </div>

              {/* Stars */}
              <div className="flex space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="text-orange-400 fill-orange-400" size={20} />
                ))}
              </div>

              {/* Testimonial Text */}
              <p className="text-white text-lg mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="border-t border-white/20 pt-4">
                <p className="text-white font-bold text-lg">
                  {testimonial.name}
                </p>
                <p className="text-orange-400 text-sm">
                  {testimonial.role}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-orange-400 mb-2">
              1000+
            </div>
            <div className="text-white text-sm md:text-base">
              Alunos Aprovados
            </div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-orange-400 mb-2">
              98%
            </div>
            <div className="text-white text-sm md:text-base">
              Satisfação
            </div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-orange-400 mb-2">
              8
            </div>
            <div className="text-white text-sm md:text-base">
              Disciplinas
            </div>
          </div>
          <div className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-orange-400 mb-2">
              50%
            </div>
            <div className="text-white text-sm md:text-base">
              de Desconto
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
